export default __webpack_public_path__ + "static/media/me-1.21755e02.JPG";